import { Component, Inject } from '@angular/core';
import { ITextModalAction, ITextModalData, MODAL_CONTROLLER, MODAL_DATA, ModalController } from '../../interfaces/modal';
import { ModalComponent } from '../modal/modal.component';
import { ModalContentComponent } from '../modal-content/modal-content.component';
import { NgClass } from '@angular/common';
import { ModalButtonsComponent } from '../modal-buttons/modal-buttons.component';
import { ModalButtonComponent } from '../modal-button/modal-button.component';

@Component({
    selector: 'gbc-text-modal',
    templateUrl: './text-modal.component.html',
    styleUrls: ['./text-modal.component.css'],
    imports: [
    ModalComponent,
    ModalContentComponent,
    ModalButtonsComponent,
    ModalButtonComponent,
    NgClass
],
})
export class TextModalComponent {
  constructor(
    @Inject(MODAL_DATA) public data: ITextModalData,
    @Inject(MODAL_CONTROLLER)
    private readonly controller: ModalController<ITextModalAction>,
  ) {}

  selectAction(action: ITextModalAction) {
    this.controller.complete(action);
  }
}
